__webpack_require__.p = "https://tipping.super.rugby/";